import React from 'react';
import type { Opportunity } from '../../types';

export function SalaryCard({ opportunity }: { opportunity: Opportunity }) {
  if (!opportunity.salary && !opportunity.salaryLevel) return null;

  return (
    <div className="wfx-opp-salary-card glass-surface">
      <span className="wfx-opp-competition-label">Salary</span>
      <strong>{opportunity.salary ?? 'As per rules'}</strong>
      <div className="wfx-opp-salary-meta">
        {opportunity.salaryLevel && <span className="chip-pill">{opportunity.salaryLevel}</span>}
        {opportunity.salaryType && <span className="chip-pill">{opportunity.salaryType}</span>}
      </div>
    </div>
  );
}
